module.exports = __webpack_public_path__ + "media/8an-rooster.12870700.mp3";